import React from 'react';

import * as S from './styles';

const Header: React.FC = () => {
  return (
    <S.Container>
      <S.Wrapper>
        <S.Title
          className="wow animate__animated animate__fadeIn"
          data-wow-duration="500ms"
        >
          Romance
          <br />
          Atualizado
          <S.Credit>
            <p>
              Por Isabela Yu
              <br />
              Fotos: Jenny Brough
            </p>
          </S.Credit>
        </S.Title>
        <S.Text
          className="wow animate__animated animate__fadeIn"
          data-wow-duration="500ms"
          data-wow-delay="200ms"
        >
          A estética exagerada do movimento New Romantic, que marcou a década de
          1980, continua sendo revisitada pela cultura pop. Na beleza, a regra é
          não ter limites: quanto mais colorido e dramático, melhor!
        </S.Text>
      </S.Wrapper>
    </S.Container>
  );
};

export default Header;
